import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFavorites } from 'redux-implementations/favorites';
import State, { RequestStates } from 'types/State';

export default function useFetchFavorites(forceFetch?: boolean): { requestState: RequestStates } {
  const dispatch = useDispatch();
  const isSignedIn = useSelector((state: State) => state?.session?.isSignedIn);
  const requestState = useSelector((state: State) => state?.favorites?.requestState);
  const shouldFetch = forceFetch ? true : requestState === RequestStates.Unstarted;
  useEffect(() => {
    if (isSignedIn && shouldFetch) {
      dispatch(fetchFavorites());
    }
  }, [dispatch, isSignedIn, shouldFetch]);
  return { requestState };
}
